import { VoucherServiceAdapter } from '@/usecases/'
import request from '@/common/request'
import { Voucher } from '@/models'

const PATH = '/vouchers'
export class VoucherService implements VoucherServiceAdapter {
	async update(voucher: Voucher): Promise<Voucher> {
		return request.put(`${PATH}/${voucher.id}`, voucher)
	}
}
